import { observable, action, makeObservable } from "mobx";

class GameData {
  creditPower = 0;
  savings = 0;
  transactions = [];
  decisionNumber = 0;

  constructor() {
    // Apply MobX observables and actions
    makeObservable(this, {
      creditPower: observable,
      savings: observable,
      transactions: observable,
      decisionNumber: observable,
      reset: action,
      incrementCreditPower: action,
      setCreditPower: action,
      incrementSavings: action,
      setSavings: action,
      setTransactions: action,
      incrementDecisionNumber: action,
      setDecisionNumber: action,
    });
  }

  reset = () => {
    this.creditPower = 0;
    this.savings = 0;
    this.transactions = [];
    this.decisionNumber = 0;
  };

  incrementCreditPower = (delta) => {
    this.creditPower += delta;
  };

  setCreditPower = (creditPower) => {
    this.creditPower = creditPower;
  };

  incrementSavings = (delta) => {
    this.savings += delta;
  };

  setSavings = (savings) => {
    this.savings = savings;
  };

  setTransactions = (transactions) => {
    this.transactions = transactions;
  };

  incrementDecisionNumber = (increment = 1) => {
    this.decisionNumber += increment;
  };

  setDecisionNumber = (decisionNumber) => {
    this.decisionNumber = decisionNumber;
  };
}

const data = new GameData();

export default data;
